import React from 'react';
import styles from "./style/wrapper.module.scss";

export default function Wrapper({children}) {
  return (
    <div className={styles['glass-effect-wrapper']}>{children}</div>
  )
}
